/**
 * Chart.js global görünümü — tüm yazılımdaki grafikler TMS Control Tower (Ocean / Air / Road)
 * dashboard'larıyla aynı dili kullanır.
 *
 * Bu dosya App.js'te chartDarkMode'dan ÖNCE import edilmelidir: chartDarkMode açık tema
 * varsayılanlarını (renk / ızgara) import anında saklar ve koyu moddan dönünce onları geri yükler.
 */
import {
    Chart,
    Legend,
    Tooltip,
    ArcElement,
    BarElement,
    LineElement,
    PointElement,
    BarController,
    LineController,
} from "chart.js";

// Varsayılanları ayarlamadan önce ilgili eklenti / elemanlar kaydedilmeli: Chart.js bunların
// varsayılan nesnelerini (defaults.plugins.legend, defaults.elements.bar, ...) ancak kayıtta oluşturur.
Chart.register(Legend, Tooltip, ArcElement, BarElement, LineElement, PointElement, BarController, LineController);

// Control Tower paleti (teal, mavi, lacivert, turuncu, yeşil, mor, kırmızı, gri, camgöbeği, pembe)
export const TMS_CHART_PALETTE = [
    "#0E9F9A",
    "#2563EB",
    "#0B1F3A",
    "#D97706",
    "#16A34A",
    "#7C3AED",
    "#DC2626",
    "#64748B",
    "#0891B2",
    "#DB2777",
];

const FONT_FAMILY = '"Roboto", "Helvetica", "Arial", sans-serif';

Chart.defaults.font.family = FONT_FAMILY;
Chart.defaults.font.size = 11;
Chart.defaults.color = "#64748B";
Chart.defaults.borderColor = "#EEF2F6";

Chart.defaults.plugins.legend.labels.usePointStyle = true;
Chart.defaults.plugins.legend.labels.boxWidth = 8;
Chart.defaults.plugins.legend.labels.boxHeight = 8;
Chart.defaults.plugins.legend.labels.padding = 14;

Chart.defaults.plugins.tooltip.backgroundColor = "#0B1F3A";
Chart.defaults.plugins.tooltip.padding = 10;
Chart.defaults.plugins.tooltip.cornerRadius = 6;
Chart.defaults.plugins.tooltip.titleFont = { family: FONT_FAMILY, weight: "600" };
Chart.defaults.plugins.tooltip.bodyFont = { family: FONT_FAMILY };
Chart.defaults.plugins.tooltip.usePointStyle = true;

// CRM dashboard'larının global kaydettiği gölge eklentisi; düz Control Tower görünümünde kapalı
Chart.defaults.plugins.shadow = false;

Chart.defaults.elements.bar.borderRadius = 4;
Chart.defaults.elements.line.tension = 0.35;
Chart.defaults.elements.line.borderWidth = 2;
Chart.defaults.elements.point.radius = 3;
Chart.defaults.elements.point.hoverRadius = 5;
Chart.defaults.elements.arc.borderWidth = 2;
Chart.defaults.elements.arc.borderColor = "#FFFFFF";
Chart.defaults.datasets.bar.maxBarThickness = 36;

const hasColor = (value) =>
    value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);

/**
 * Rengi tanımlanmamış veri serilerine Control Tower paletinden renk verir.
 * Sayfanın kendi verdiği renklere dokunmaz.
 */
const tmsPalettePlugin = {
    id: "tmsPalette",
    beforeUpdate(chart) {
        const chartType = chart.config.type;
        (chart.data?.datasets || []).forEach((dataset, datasetIndex) => {
            const type = dataset.type || chartType;
            const isRadial = ["doughnut", "pie", "polarArea"].includes(type);

            if (isRadial) {
                if (!hasColor(dataset.backgroundColor)) {
                    dataset.backgroundColor = (dataset.data || []).map(
                        (_, i) => TMS_CHART_PALETTE[i % TMS_CHART_PALETTE.length]
                    );
                }
                return;
            }

            if (hasColor(dataset.backgroundColor) || hasColor(dataset.borderColor)) return;

            const color = TMS_CHART_PALETTE[datasetIndex % TMS_CHART_PALETTE.length];
            if (type === "line" || type === "radar") {
                dataset.borderColor = color;
                dataset.backgroundColor = `${color}22`;
                dataset.pointBackgroundColor = color;
            } else {
                dataset.backgroundColor = color;
                dataset.borderColor = color;
            }
        });
    },
};

Chart.register(tmsPalettePlugin);
